import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs, formatCurrency } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import ToastPage from '../../includes/ToastPage';
import '../../../assets/styles/RM.css'
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';
import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import { Modal } from '@material-ui/core';
import { modifyUntaggedPayment } from '../../../services/apis/shareManagement/BuyOrdersApi';


export default function UntaggedPaymentPage() {

    const { setCurrModule, allowedFunc, token, logout, setLoginError, setShowSuccess } = useLogin()
    const { untaggedPaymentByType, untaggedPaymentTableData } = useBuyOrderContext();


    const history = useHistory()

    const [classificationFilter, setClassificationFilter] = useState(Object.keys(configs.untagged_payment_classification)[0]);
    const [statusFilter, setStatusFilter] = useState(Object.keys(configs.untagged_payment_status)[0]);

    const [rowsDisplay, setRowsDisplay] = useState(configs.defaultRowPerPage);
    const [page, setPage] = useState(configs.startPage);

    const [modalData, setModalData] = useState("");
    const [error, setError] = useState("");
    const [dataToUpdate, setDataToUpdate] = useState("");
    const [remark, setRemark] = useState("");
    const [UntaggedModal, setUntaggedModal] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                if (allowedFunc.includes(configs.functionList['buy_recons:buy_recons'])) {
                    setCurrModule(configs.modules.untaggedPaymnet)
                } else {
                    return history.goBack()
                }
            } catch (error) {

            }
        })()
    }, [])

    useEffect(() => {
        if (page > configs.startPage) {
            setPage(configs.startPage)
        } else {
            untaggedPaymentByType(statusFilter, classificationFilter, page, configs.recordPerPage, true)
        }
    }, [statusFilter, classificationFilter])

    useEffect(() => {
        (async () => {
            untaggedPaymentByType(statusFilter, classificationFilter, page, configs.recordPerPage, page === configs.startPage ? true : false)
        })()
    }, [page])


    const columns = [{ field: "id", headerName: "ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
    { field: "transaction_id", headerName: "Transaction Id", minWidth: 90, flex: 0.1, cellClassName: "break-text" },
    { field: "utr", headerName: "UTR", minWidth: 90, flex: 0.1, cellClassName: "break-text" },
    {
        field: "amount", headerName: "Amount", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
            return formatCurrency(parseFloat(params.row.amount))
        }, valueGetter: (value) => value.row.amount
    },
    { field: "bank", headerName: "Bank", minWidth: 90, flex: 0.1, cellClassName: "break-text" },
    { field: "type", headerName: "Type", minWidth: 90, flex: 0.1, cellClassName: "break-text" },
    { field: "narration", headerName: "Narration", minWidth: 200, flex: 0.1, cellClassName: "break-text" },
    { field: "classification", headerName: "Classification", minWidth: 90, flex: 0.1, cellClassName: "break-text" },
    { field: "status", headerName: "Status", minWidth: 200, flex: 0.5, cellClassName: "break-text" },
    { field: "classification_remark", headerName: "Remark", minWidth: 200, flex: 0.5, cellClassName: "break-text" },
    { field: "order_id", headerName: "Order Id", minWidth: 200, flex: 0.5, cellClassName: "break-text" },
    {
        field: "is_tranching_allowed", headerName: "Tranching allowed", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
            return params.row.is_tranching_allowed ? "Yes" : "No"
        }, valueGetter: (value) => value.row.is_tranching_allowed ? "Yes" : "No"
    },
    { field: "transaction_date", headerName: "Transaction Date", minWidth: 50, flex: 0.4, cellClassName: "break-text" },
    ...(statusFilter === Object.keys(configs.untagged_payment_status)[1] ? [{
        field: "classify", headerName: "Classify", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return !cellValues.row.classification ? <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setModalData(cellValues.row)
                setUntaggedModal('classify')
            }}>Classify</a> : null
        }
    }] : []),
    ...(statusFilter === Object.keys(configs.untagged_payment_status)[1] ? [{
        field: "tranching", headerName: "Tranching", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return cellValues.row.is_tranching_allowed ? <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setModalData(cellValues.row)
                setUntaggedModal("tranch")
            }}>Tranch</a> : null
        }
    }] : []),
    ...(statusFilter === Object.keys(configs.untagged_payment_status)[1] ? [{
        field: "refund_initiate", headerName: "Initiate Refund", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setModalData(cellValues.row)
                setUntaggedModal("refund-initiate")
            }}>Initiate Refund</a>
        }
    }] : []),
    ...(statusFilter === Object.keys(configs.untagged_payment_status)[2] ? [{
        field: "complete_refund", headerName: "Complete Refund", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setModalData(cellValues.row)
                setUntaggedModal("refund-complete")
            }}>Complete Refund</a>
        }
    }] : [])
    ]


    const handleClose = () => {
        try {
            setModalData("");
            setError("");
            setUntaggedModal(false)
            setDataToUpdate("")
            setRemark("")
        } catch (error) {
            console.error(error);
        }
    }

    async function manageUntaggedData() {
        try {
            const payloadValue = (UntaggedModal === "refund-initiate" || UntaggedModal === "refund-complete") ? remark : dataToUpdate;
            if (!payloadValue && (UntaggedModal === "refund-initiate" || UntaggedModal === "refund-complete")) {
                setError("Please enter a remark.")
            } else if (!dataToUpdate && UntaggedModal !== "refund-initiate" && UntaggedModal !== "refund-complete") {
                setError("Invalid Value. Kindly select/enter valid value.")
            } else if (UntaggedModal === 'tranch' && modalData.amount < parseFloat(dataToUpdate)) {
                setError("Tranching amount cannot be greater than available amount.")
            } else {
                let response = await modifyUntaggedPayment(token, modalData.id, payloadValue, UntaggedModal, (UntaggedModal === "refund-initiate" || UntaggedModal === "refund-complete") ? undefined : remark);
                if (response && response.status === 200) {
                    setShowSuccess(true);
                    handleClose();
                    untaggedPaymentByType(statusFilter, classificationFilter, page, configs.allRecordsFetchedTillNow, true)
                } else if (response && response.status === 401) {
                    logout();
                    setLoginError(configs.unauthorizedErrorMessage);
                }
                else { setError(response.data.error); }
            }
        } catch (error) {
            console.error(error);
            setError(error.error ? error.error : error)
        }
    }

    // role management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='rmContainer' className="rm-container">
                    <div id="newsListPage" className='' style={{ width: "100%" }}>
                        <div className="row d-flex align-items-center mt-2 ml-2 mb-1 mr-3">
                            <div className="col-lg-4 col-6 m-0 p-0">
                                <p className="h4 text-custom-grey">Untagged Payment</p>
                            </div>
                            <div className='col-4'>
                                <button className="btn btn-primary" onClick={(e) => {
                                    e.preventDefault()
                                    untaggedPaymentByType(statusFilter, classificationFilter, configs.startPage, configs.allRecordsFetchedTillNow, true)
                                }}>Get All Records</button>
                            </div>
                            <div className="col-lg-4 col-6 text-right m-0 p-0 filterArea">
                                <select className='' id="selectRemarkData" value={statusFilter} onChange={(e) => {
                                    e.preventDefault()
                                    setStatusFilter(e.target.value)
                                }}>
                                    {Object.keys(configs.untagged_payment_status).map((item, index) => {
                                        return <option key={index} value={item}>{configs.untagged_payment_status[item]}</option>
                                    }
                                    )}
                                </select>
                                <select className='' id="adminFilter" value={classificationFilter} onChange={(e) => {
                                    e.preventDefault()
                                    setClassificationFilter(e.target.value)
                                }}>
                                    {Object.keys(configs.untagged_payment_classification).map((item, index) => {
                                        return <option key={index} value={item}>{configs.untagged_payment_classification[item]}</option>
                                    }
                                    )}
                                </select>
                            </div>
                        </div>

                        {untaggedPaymentTableData && untaggedPaymentTableData.length > 0 ?
                            <>
                                <div className="nm-role-table m-2">
                                    <DataGrid
                                        rows={untaggedPaymentTableData}
                                        headerHeight={30}
                                        rowHeight={40}
                                        columns={columns}
                                        resizable={true}
                                        pageSize={rowsDisplay}
                                        pagination
                                        components={{
                                            Toolbar: GridToolbar,
                                        }}
                                        onPageChange={(currenIndex) => {
                                            if ((currenIndex + 1) === Math.ceil(untaggedPaymentTableData.length / rowsDisplay)) {
                                                setPage(page + 1);
                                            }
                                        }}
                                        onPageSizeChange={(rowsBeingDisplayed) => {
                                            setRowsDisplay(rowsBeingDisplayed);
                                        }}

                                    />
                                </div>
                            </>
                            : <div className="loader"></div>}
                    </div>
                    <ToastPage />
                    {/* // ------------------------manage untagged payment------------------------------- */}
                    < Modal open={UntaggedModal} onClose={handleClose} style={{ overflow: "scroll" }}>
                        <div className="modal-fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="text-custom-grey h6" id="exampleModalLabel">{UntaggedModal === 'classify' ? 'Classify' : UntaggedModal === "tranch" ? "Tranch" : UntaggedModal === "refund-initiate" ? "Initiate Refund of" : UntaggedModal === "refund-complete" ? "Complete Refund of" : ""} Transaction - {modalData.transaction_id}</h5>
                                        <button type="button" className="close" aria-label="Close" onClick={(e) => {
                                            e.preventDefault()
                                            handleClose()
                                        }}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <form action="">
                                            <div className="form-group">
                                                {UntaggedModal === 'classify' ?
                                                    <>
                                                        <select className='' id="adminClassifyFilter" value={dataToUpdate} onChange={(e) => {
                                                            e.preventDefault()
                                                            setDataToUpdate(e.target.value)
                                                        }}>
                                                            {Object.keys(configs.untagged_payment_classification).map((item, index) => {
                                                                return index > 0 ? <option key={index} value={item}>{configs.untagged_payment_classification[item]}</option> : <option disabled={true} value="">Select Classification</option>
                                                            }
                                                            )}
                                                        </select>
                                                        <label className="mt-2">Remark</label>
                                                        <textarea className="form-control" rows={3} value={remark} placeholder="Enter remark (optional)" onChange={(e) => setRemark(e.target.value)} />
                                                    </>
                                                    : (UntaggedModal === "tranch" ?
                                                        <>
                                                            <p><b>Available Amount:</b> {formatCurrency(parseFloat(modalData.amount))}<br /></p>
                                                            <input value={dataToUpdate} placeholder="Enter Amount" onChange={(e) => {
                                                                if (isNaN(e.target.value) && UntaggedModal === "tranch") { }
                                                                else { setDataToUpdate(e.target.value) }
                                                            }} />
                                                            <label className="mt-2">Remark</label>
                                                            <textarea className="form-control" rows={3} value={remark} placeholder="Enter remark (optional)" onChange={(e) => setRemark(e.target.value)} />
                                                        </>
                                                        : (UntaggedModal === "refund-initiate" || UntaggedModal === "refund-complete") ?
                                                            <>
                                                                <label><b>Remark</b></label>
                                                                <textarea className="form-control" rows={3} value={remark} placeholder="Enter remark" onChange={(e) => setRemark(e.target.value)} />
                                                            </>
                                                            : null
                                                    )
                                                }
                                            </div>
                                        </form>
                                        <div className="form-check p-0">
                                            <p className="text-danger" id="addUtrError">{error}</p>
                                        </div>
                                    </div>
                                    <div className="modal-footer justify-content-center">
                                        <button id="classifyBtn" type="button" className="btn btn-primary" onClick={(e) => {
                                            e.preventDefault()
                                            manageUntaggedData()
                                        }}>Update</button>
                                        <div id="classifyBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal >
                </div >
            </div >
        </>
    )
}